<template>
  <div class="pre-enrolled">
    <!-- 汇总 -->
    <div class="summary" v-if="!shownull">
      共 {{ totalCount }} 条 · 第 {{ page }} / {{ totalPages }} 页 · 每页 {{ pageSize }} 条
    </div>

    <!-- 列表 -->
    <div class="list-card" v-if="!shownull">
      <div class="list-head flex flex-a-i-center">
        <span class="c-name">名字</span>
        <span class="c-mobile">手机号</span>
        <span class="c-inviter">推荐人</span>
        <span class="c-pay">付款时间</span>
        <span class="c-op">操作</span>
      </div>
      <div class="list-row flex flex-a-i-center" v-for="(e, i) in pageLists" :key="`${e.id}_${i}`"
        @click="toDetail(e)">
        <span class="c-name ellipsis">{{ e.show_name || e.true_name || '-' }}</span>
        <span class="c-mobile">{{ maskMobile(e.binding) }}</span>
        <span class="c-inviter ellipsis">{{ e.inviter_name || '-' }}</span>
        <span class="c-pay">
          <template v-if="e.pay_time_text">
            <p class="pay-date">{{ payPart(e, 0) }}</p>
            <p class="pay-time">{{ payPart(e, 1) }}</p>
          </template>
          <span v-else>-</span>
        </span>
        <span class="c-op">
          <i class="op-btn">详情</i>
        </span>
      </div>
    </div>

    <!-- 空态 -->
    <div class="empty flex flex-j-c-center flex-a-i-center" v-if="shownull">
      <img src="@/assets/null.png" />
      <p>暂无数据</p>
    </div>

    <!-- 翻页 -->
    <div class="pager" v-if="!shownull && totalPages > 1">
      <span :class="['pg-btn', { disabled: page <= 1 }]" @click="goPage(1)">首页</span>
      <span :class="['pg-btn', { disabled: page <= 1 }]" @click="goPage(page - 1)">上一页</span>
      <span class="pg-num">{{ page }} / {{ totalPages }}</span>
      <span :class="['pg-btn', { disabled: page >= totalPages }]" @click="goPage(page + 1)">下一页</span>
      <span :class="['pg-btn', { disabled: page >= totalPages }]" @click="goPage(totalPages)">尾页</span>
    </div>
  </div>
</template>

<script>
import { teacherForder } from '@/api'
import { Indicator, Toast } from 'mint-ui'

export default {
  name: 'PreEnrolled',
  data() {
    return {
      pageLists: [], // 当前页列表
      page: 1, // 当前页码
      pageSize: 15, // 每页条数
      totalCount: 0, // 总条数（用于算总页数与展示）
      shownull: false, // 空态
      kw: '', // 搜索词
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.pageSize) || 0
    },
  },
  created() {
    this.kw = this.$route.query.kw || ''
    this.getpageData()
  },
  watch: {
    // 切 tab / 搜索时回到第 1 页重新拉取
    $route(a) {
      this.page = 1
      this.shownull = false
      this.kw = a.query.kw || ''
      this.pageLists = []
      this.getpageData()
    },
  },
  methods: {
    // 四向翻页：越界直接拦掉，不发无效请求
    goPage(p) {
      if (this.pageLists.length === 0) return false
      if (p < 1) p = 1
      if (p > this.totalPages) p = this.totalPages
      if (p === this.page) return false
      this.page = p
      this.getpageData()
      window.scrollTo(0, 0)
    },
    // 付款时间拆成「日期 / 时分」两行，手机端才放得下
    payPart(e, i) {
      const t = e.pay_time_text || ''
      return t.split(' ')[i] || ''
    },
    // 列表里手机号中间四位打码，完整号码进详情页看
    maskMobile(m) {
      const s = String(m || '')
      return s.length === 11 ? `${s.slice(0, 3)}****${s.slice(7)}` : s || '-'
    },
    toDetail(e) {
      this.$router.push({ path: `/EnrolledDetail?id=${e.id}` })
    },
    // 列表数据获取
    getpageData() {
      Indicator.open()
      teacherForder({ page: this.page, limit: this.pageSize, type: 2, keyword: this.kw })
        .then((res) => {
          Indicator.close()
          if (res.code === 0) {
            const list = res.data || []
            this.totalCount = Number(res.totalCount) || 0
            // 停在已被删空的尾页时自动退回最后一页，避免卡在空白页
            if (list.length === 0 && this.totalCount > 0 && this.page > this.totalPages) {
              this.page = this.totalPages
              this.getpageData()
              return
            }
            // 整页替换（原来是 concat 追加），翻页不会残留上一页的数据
            this.pageLists = list
            this.shownull = list.length === 0
          } else {
            this.pageLists = []
            this.totalCount = 0
            this.shownull = true
            Toast({ message: res.msg || '暂无数据', className: 'iconfont icon-close' })
          }
        })
        .catch(() => {
          Indicator.close()
          this.pageLists = []
          this.totalCount = 0
          this.shownull = true
        })
    },
  },
}
</script>

<style lang="less" scoped>
.pre-enrolled {
  padding: 1.64rem 0 0.2rem;
  min-height: 100vh;
  background: #eee;

  .summary {
    font-size: 0.12rem;
    color: #999;
    padding: 0.12rem 0.16rem 0.06rem;
  }

  .list-card {
    width: 3.43rem;
    margin: 0 auto;
    background: #fff;
    border-radius: 0.05rem;
    overflow: hidden;

    .list-head {
      height: 0.32rem;
      background: #fafafa;
      font-size: 0.11rem;
      color: #999;
      border-bottom: 1px solid #f0f0f0;
    }

    .list-row {
      min-height: 0.48rem;
      font-size: 0.12rem;
      color: #333;
      border-top: 1px solid #f5f5f5;

      &:first-of-type {
        border-top: none;
      }

      &:active {
        background: #fafafa;
      }
    }

    .c-name {
      width: 0.62rem;
      padding-left: 0.08rem;
    }

    .c-mobile {
      width: 0.86rem;
    }

    .c-inviter {
      width: 0.52rem;
    }

    .c-pay {
      width: 0.72rem;
      line-height: 1.3;
      font-size: 0.11rem;
      color: #666;

      .pay-time {
        color: #999;
      }
    }

    .c-op {
      flex: 1;
      text-align: center;

      .op-btn {
        display: inline-block;
        font-style: normal;
        font-size: 0.11rem;
        color: #fff;
        background: linear-gradient(90deg, #fabf01, #fa9901);
        border-radius: 0.1rem;
        padding: 0.03rem 0.1rem;
      }
    }
  }

  .empty {
    flex-direction: column;
    padding: 0.8rem 0;
    color: #fabf01;

    img {
      width: 0.5rem;
      height: 0.5rem;
    }

    p {
      font-size: 0.13rem;
      color: #999;
      margin-top: 0.06rem;
    }
  }

  .pager {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.16rem 0 0.04rem;

    .pg-btn {
      font-size: 0.12rem;
      color: #666;
      background: #fff;
      border: 1px solid #ddd;
      border-radius: 0.04rem;
      padding: 0.05rem 0.09rem;
      margin: 0 0.03rem;

      &.disabled {
        color: #bbb;
        background: #f7f7f7;
      }
    }

    .pg-num {
      font-size: 0.12rem;
      color: #333;
      padding: 0 0.04rem;
      min-width: 0.44rem;
      text-align: center;
    }
  }
}
</style>
